import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/spotpris/se3")({
  head: () => seoHead("/spotpris/se3"),
  beforeLoad: () => permanentRedirect("/spotpris/elomrade-se3"),
});
